currentPlanType